// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__146Io","list":"styles_list__2SwUJ"};